var map = {
	"./da.json": 899,
	"./de.json": 900,
	"./en.json": 901,
	"./es.json": 902,
	"./fr.json": 903,
	"./ko.json": 904,
	"./pl.json": 905,
	"./pt.json": 906,
	"./ru.json": 907,
	"./sv.json": 908,
	"./uk.json": 909,
	"./zh_CN.json": 910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 898;